import { createContext, useContext } from "react";
const PreviewContext = createContext(false);
export const PreviewProvider = PreviewContext.Provider;
export const useIsPreview = () => useContext(PreviewContext);
